/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
function plural(val) {
  const n = val;
  return 5;
}
export default ["mua", [["comme", "lilli"], u, u], u, [["Y", "L", "Z", "O", "A", "G", "E"], ["Cya", "Cla", "Czi", "Cko", "Cka", "Cga", "Cze"], ["Com’yakke", "Comlaaɗii", "Comzyiiɗii", "Comkolle", "Comkaldǝɓlii", "Comgaisuu", "Comzyeɓsuu"], ["Cya", "Cla", "Czi", "Cko", "Cka", "Cga", "Cze"]], u, [["O", "A", "I", "F", "D", "B", "L", "M", "E", "U", "W", "Y"], ["FLO", "CLA", "CKI", "FMF", "MAD", "MBI", "MLI", "MAM", "FDE", "FMU", "FGW", "FYU"], ["Fĩi Loo", "Cokcwaklaŋne", "Cokcwaklii", "Fĩi Marfoo", "Madǝǝuutǝbijaŋ", "Mamǝŋgwãafahbii", "Mamǝŋgwãalii", "Madǝmbii", "Fĩi Dǝɓlii", "Fĩi Mundaŋ", "Fĩi Gwahlle", "Fĩi Yuru"]], u, [["KK", "PK"], u, ["KǝPel Kristu", "Pel Kristu"]], 1, [6, 0], ["d/M/y", "d MMM y", "d MMMM y", "EEEE d MMMM y"], ["HH:mm", "HH:mm:ss", "HH:mm:ss z", "HH:mm:ss zzzz"], ["{1} {0}", u, u, u], [",", ".", ";", "%", "+", "-", "E", "×", "‰", "∞", "NaN", ":"], ["#,##0.###", "#,##0%", "¤#,##0.00", "#E0"], "XAF", "FCFA", "solai BEAC", {
  "JPY": ["JP¥", "¥"],
  "USD": ["US$", "$"]
}, "ltr", plural];
